import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSolletWallet(),
      getMathWallet(),
    ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button">
          <img src="/icons/close.svg" alt="" onClick={toggleMenu} />
        </div>
        <ul>
          <li>
            <img className="mobile-nav-logo" src="/img/logo.png" alt="" />
          </li>
          <li>
            <a href="/#mint" onClick={toggleMenu}>
              Mint
            </a>
          </li>
          <li>
            <a href="/#overview" onClick={toggleMenu}>
              Overview
            </a>
          </li>
          <li>
            <a href="/#roadmap" onClick={toggleMenu}>
              Roadmap
            </a>
          </li>
          <li>
            <a href="/#link4" onClick={toggleMenu}>
              
            </a>
          </li>
          <li>
            <div className="social-icons">
              <a href="https://twitter.com" target="_blank" rel="noreferrer">
                <img className="nav-social" src="/icons/twitter.svg" alt="" />
              </a>
              <a href="https://discord.com" target="_blank" rel="noreferrer">
                <img className="nav-social" src="/icons/discord.svg" alt="" />
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="" />
      </div>
      <nav>
        <div className="nav-container">
          <img className="nav-logo" src="/img/logo.png" alt="" />
          <a className="hide-800" href="/#mint">
            Mint
          </a>
          <a className="hide-800" href="/#overview">
            Overview
          </a>
          <a className="hide-800" href="/#roadmap">
            Roadmap
          </a>
          <a className="hide-800" href="/">
            
          </a>
          <div className="social-icons hide-800">
            <a href="https://twitter.com/blackapecard" target="_blank" rel="noreferrer">
              <img className="nav-social" src="/icons/twitter.svg" alt="" />
            </a>
            <a href="https://discord.gg/B8RtZtbhQ2" target="_blank" rel="noreferrer">
              <img className="nav-social" src="/icons/discord.svg" alt="" />
            </a>
          </div>
        </div>
      </nav>
	  <div id="link5" className="container">
          
        </div>
      <div className="content-wrapper">
        <header className="card" id="mint">
          <div style={{ padding: "0 24px 0 24px 0" }}>
            <h3 className="text-secondary-color">Mint Your</h3>
            <h1 className="pb-3">Black Ape Card Pass</h1>
			<div className="mint-card">
			<img src="https://zxvl.one/pic/bgbg.png" alt=""/>
			</div>
            <p className="text-secondary-color">
              888 Black Ape Card | Tools Auto Mint, NFT Snipe, Stealth Mint 
                     Detector & Whitelisting Project on #Solana.
            </p>
          </div>
          <div>
            <ThemeProvider theme={theme}>
              <ConnectionProvider endpoint={endpoint}>
                <WalletProvider wallets={wallets} autoConnect>
                  <WalletDialogProvider>
                    <Minter
                      candyMachineId={candyMachineId}
                      connection={connection}
                      startDate={startDateSeed}
                      txTimeout={txTimeout}
                      rpcHost={rpcHost}
                    />
                  </WalletDialogProvider>
                </WalletProvider>
              </ConnectionProvider>
            </ThemeProvider>
          </div>
        </header>

        <div id="link2" className="container">
          
        </div>

        <div id="overview" className="container card">
          <h1 className="pb-3">Black Ape Card</h1>
		  <div className="card1">
			<img className="img1"src="/img/Black Ape Card3.png" alt=""/>
			<img className="img2"src="/img/Black Ape Card3.png" alt=""/>
			<img className="img3"src="/img/Black Ape Card3.png" alt=""/>
		  </div>
        </div>

        <div id="roadmap" className="container faq">
          <h1 style={{ padding: "0 0 24px 0" }}>Roadmap</h1>
          <div>
            <h4>Phase I</h4>
            <p>
              Whitelist Bot : Will automatically provide a whitelist role to every NFT Project.
            </p>

            <hr />
          </div>

          <div>
            <h4>Phase II</h4>
            <p>
              Candy Machine V2 Tracker : launch an CandyMachine ID/cmid for upcoming NFT Projects.
            </p>

            <hr />
          </div>

          <div>
            <h4>Phase III</h4>
            <p>
              Stealth Mint Bot : A Bot that automatically aiming and buying the NFT's at the lowest price on market (Magic Eden, Solanart, etc)
            </p>

            <hr />
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
